import { MediaWrapperContainerTypeEnum } from '@/utils/aspectRatioUtils';

import type { ContentfulSliderProductsManualFragment } from '@/graphql/contentful/api';
import type {
  CmsExtraDataRecord,
  ContentfulData,
} from '@/integrations/contentful';

import { type ItemData, renderCollectionItem } from '../DoubleCard';
import { SliderProducts } from '../SliderProducts';

export const renderGridItem = (
  data: ContentfulData,
  extraDataRecord?: CmsExtraDataRecord,
  draftMode?: boolean,
) => {
  if (data?.__typename === 'SliderProductsManual') {
    const sysId = data?.sys?.id;
    const extraData = extraDataRecord
      ? extraDataRecord[sysId ?? '']
      : undefined;

    const props = data as ContentfulSliderProductsManualFragment;

    return (
      <SliderProducts
        {...props}
        disableGutters={true}
        draftMode={draftMode}
        productData={extraData?.extraData?.productData}
      />
    );
  }
  return renderCollectionItem(
    data as ItemData,
    extraDataRecord,
    MediaWrapperContainerTypeEnum.Grid,
    'Auto',
  );
};
